import type { ReactNode } from 'react'

/**
 * The hover / arrow-key readout every chart on the page shares (the design system's
 * `ci-trend__readout`): announced politely, placed over the active point, hidden when
 * there is none.
 */
export function ChartReadout({ id, left, children }: { id: string; left: number | null; children: ReactNode }) {
  return (
    <div
      id={id}
      className="ci-trend__readout"
      aria-live="polite"
      data-visible={left !== null ? 'true' : 'false'}
      style={left !== null ? { left: `${left}%` } : undefined}
    >
      {left !== null ? children : null}
    </div>
  )
}
